import {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {SearchProps} from "./types";
import {useDomainListFetcher} from "@/components/endpoint-status/domainFetcher";

type Option = {
    value: number;
    label: string;
};

const SearchDomainByName = ({onChange}: SearchProps) => {
    const [domainId, setDomainId] = useState(0);
    const intl = useIntl();
    const {fetch, domains, loading} = useDomainListFetcher();

    const loadOptions = async () => {
        if (domains.length && loading) return;

        await fetch();
    };

    const options: Option[] = domains.map((d) => ({value: d.id, label: d.name}));

    return (
        <Autocomplete<Option, false, false, false>
            sx={{minWidth: "25ch"}}
            options={options}
            loading={loading}
            onOpen={loadOptions}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.label}
            value={options.find((op) => op.value === domainId) ?? null}
            onChange={(_, val) => {
                if (val) {
                    setDomainId(0); // preserve prior behavior of clearing local selection after change
                    onChange({id: val.value, name: val.label});
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={<FormattedMessage id="domain_name" defaultMessage="Domain name" />}
                    placeholder={
                        loading ? intl.formatMessage({id: "loading.generic", defaultMessage: "Loading"}) : undefined
                    }
                    variant="outlined"
                    margin="dense"
                    size="small"
                    onClick={loadOptions}
                    style={{margin: 0}}
                />
            )}
        />
    );
};

export default SearchDomainByName;
